import type { HttpPost } from '@/shared/infra/http'
import type { PostMessage } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type MessageDto, toMessage } from './message-dto'

type PostMessageResponseDto = {
  message: MessageDto
  resolvedMentionUserIds?: string[] | null
}

export class EdgePostMessageRepository {
  constructor(private readonly http: HttpPost) {}

  execute: PostMessage = async (params) => {
    try {
      const data = await this.http.post<unknown, PostMessageResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/messages`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          body: params.body,
          mentions: params.mentions ?? [],
        },
      })
      return {
        message: toMessage(data.message),
        resolvedMentionUserIds: data.resolvedMentionUserIds ?? [],
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
